import type { Result } from "@skyware-group/iris-api-model";

import { BaseClient } from "../../clients/base/BaseClient";
import { SAMPLES_ENDPOINTS } from "./samples.consts";

/**
 * Samples API Client
 * Handles all sample-related API operations.
 */
export class SamplesClient extends BaseClient {
  /**
   * Fetch pending results for a sample by barcode/ID.
   * Results are filtered to exclude control samples and validated/rejected results.
   * @param {string} sampleId - Sample barcode/ID (case-insensitive).
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<Result[]>} Array of pending sample results.
   */
  async fetchSampleResults(sampleId: string, signal?: AbortSignal | null): Promise<Result[]> {
    return this.get<Result[]>(SAMPLES_ENDPOINTS.SAMPLE_RESULTS(sampleId), {
      signal,
    });
  }
}
